import ModalHeader from "app/pages/sales-intelligence/sub-modules/signals/components/modals/SignalsModal/ModalHeader/ModalHeader";
import SignalsModal from "app/pages/sales-intelligence/sub-modules/signals/components/modals/SignalsModal/SignalsModal";
import type { ReactNode } from "react";

import { StyledContent } from "./styles";

export type SignalManagementBaseProps = {
    headerContent: ReactNode;
    children: ReactNode | ReactNode[];
    isOpen: boolean;
    onReturn(): void;
    onClose(): void;
};

const SignalManagementBase = (props: SignalManagementBaseProps) => {
    const { headerContent, children, isOpen, onReturn, onClose } = props;

    return (
        <SignalsModal isOpen={isOpen}>
            <ModalHeader
                onReturn={onReturn}
                onClose={onClose}
            >
                {headerContent}
            </ModalHeader>

            <StyledContent>{children}</StyledContent>
        </SignalsModal>
    );
}

export default SignalManagementBase;
